import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';
import * as _ from 'lodash';
import * as moment from 'moment';
import { FollowUpModel } from '../../../model/index';
import { BackupFollowUpClientService, CommonService, FollowUpClientUploadService, SubscribeService } from '../../../services/index';
import * as fromCommonStore from '../../../store';
import * as fromRootStore from '../../../reducers';
import swal from 'sweetalert2';
@Component({
    selector: 'backup-tab',
    templateUrl: './backupFollowUpClient.component.html',
})
export class BackupFollowUpClientComponent implements OnInit {

    itemList: any;
    columns = [];
    isLoadMask: Promise<any>;
    filterData = {
    };
    loadingIndicator: boolean = true;
    page = {
        limit: 25,
        count: 0,
        offset: 0,
        orderBy: 'cbfd.date',
        orderDir: 'asc'
    };
    totTask: number = 0;
    comTask: number = 0;
    followUpStatusList: any;
    hasOwnRecord: boolean = true;
    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('optionTemplate') optionTemplate: TemplateRef<any>;
    @ViewChild('filterPanel') filterPanel;
    @ViewChild('clientAutoComp') clientAutoComp;

    filteredFollowupStatus: Observable<any[]>;

    bsModalRef: BsModalRef;
    branchList: any[] = [];
    followupNameList: Array<any>;
    currentYear = new Date().getFullYear();
    yearList: any[] = [];
    monthList: any[] = [];
    followUpListdt: any;
    backupFollowUpClientList: FollowUpModel[];
    selected = [];
    rows = [];
    existClient: { 'client_id': number; 'fol_status': number; 'assignee_id': number; };
    selectedArray: any;

    constructor(public store: Store<fromRootStore.State>, private modalService: BsModalService, private commonService: CommonService, private backupFollowUpClientService: BackupFollowUpClientService, private followUpClientUploadService: FollowUpClientUploadService, public subscribeService: SubscribeService) {

    }

    ngOnInit(): void {
        let that = this;

        this.columns = [
            {
                prop: 'selected', name: '', sortable: false, canAutoResize: true, draggable: false, resizable: true, headerCheckboxable: true, checkboxable: true, selectAllRowsOnPage: true, width: 55, minWidth: 55, maxWidth: 55,
            },
            { name: 'SNo', prop: 'sno', width: 55, minWidth: 55, maxWidth: 55, sortable: false, cellTemplate: this.snoTemplate, toggle: true },
            { name: 'Date', prop: 'date', width: 100, minWidth: 100, maxWidth: 100, toggle: true },
            { name: 'Client ID', prop: 'client_no', width: 130, minWidth: 130, maxWidth: 130 },
            { name: 'Name', prop: 'client_name', sortable: false, width: 150, minWidth: 150, maxWidth: 150 },
            { name: 'Phone No', prop: 'mobile', sortable: false, width: 100, minWidth: 100, maxWidth: 100 },
            { name: 'Next Followup', prop: 'next_followup', width: 150, minWidth: 150, maxWidth: 150, toggle: true },
            { name: 'Branch', prop: 'branch', width: 100, minWidth: 100, maxWidth: 100 },
            { name: 'Assignee', prop: 'assignee', width: 100, minWidth: 100, maxWidth: 100 },

        ];

        this.yearList = this.getYearList();
        this.monthList = [{ name: 'ALL', id: '' }, { name: 'JAN', id: 0 }, { name: 'FEB', id: 1 }, { name: 'MAR', id: 2 }, { name: 'APR', id: 3 }, { name: 'MAY', id: 4 }, { name: 'JUN', id: 5 }, { name: 'JUL', id: 6 }, { name: 'AUG', id: 7 }, { name: 'SEP', id: 8 }, { name: 'OCT', id: 9 }, { name: 'NOV', id: 10 }, { name: 'DEC', id: 11 }];
        this.pageCallback({ offset: 0 });
        //TO GET BRANCH LIST
        this.store.select(fromCommonStore.getAllBranch).subscribe((res: any) => {
            if (_.isEmpty(res.data)) {
                return;
            }
            that.branchList = _.filter(res.data, function (obj) { return obj['is_crm_branch'] == 'Yes' && obj['is_hv_center'] == 'false' });
        });
        console.log(that.branchList);
        this.store.select(fromCommonStore.getAllReference).subscribe((res: any) => {
            if (_.isEmpty(res)) {
                return;
            }
            this.itemList = res;
        });

        this.store.select(fromCommonStore.getAllFollowUpStatus).subscribe((res: any) => {
            if (_.isEmpty(res.data)) {
                return;
            }
            that.followUpStatusList = _.filter(res.data, { 'team_id': 10 });
            that.followupNameList = _.filter(res.data, { 'is_working_followup': 'Yes' });

        });
    }

    getYearList() {
        this.filterData['year'] = this.currentYear;
        this.filterData['month'] = '';
        this.handleYearChange(this.currentYear);
        var minYear = this.currentYear - 9;
        var years = [{ name: 'ALL', id: '' }, { name: this.currentYear, id: this.currentYear }];

        for (var year = this.currentYear - 1; year >= minYear; year--) {
            years.push({ name: year, id: year });
        }
        return years;
    };

    handleYearChange(value) {
        if (value) {
            if (this.filterData['month'] !== '') {
                this.filterData['from_date'] = new Date(value, this.filterData['month'], 1);
                this.filterData['to_date'] = new Date(value, this.filterData['month'] + 1, 0);
            } else {
                this.filterData['from_date'] = new Date(value, 0, 1);
                this.filterData['to_date'] = new Date(value, 11, 31);
            }
        } else {
            this.filterData['month'] = '';
            this.filterData['from_date'] = null;
            this.filterData['to_date'] = null;
        }
    }

    // To handle month change for Not Willing Now Followup
    handleMonthChange(value) {
        if (value !== '') {
            this.filterData['from_date'] = new Date(this.filterData['year'], value, 1);
            this.filterData['to_date'] = new Date(this.filterData['year'], value + 1, 0);
        } else {
            this.filterData['from_date'] = new Date(this.filterData['year'], 0, 1);
            this.filterData['to_date'] = new Date(this.filterData['year'], 11, 31);
        }
    }

    onChangePageSize(limit) {
        this.page.limit = limit;
        this.getBackupFollowUpClientList();
    }

    getRowClass(row) {
        if (row.important == 'true') {
            return {
                'important-follow-up': row.important == 'true'
            };
        } else if (row.prev_day_entry == 'true') {
            return {
                'follow-up-prev-day-rec': row.prev_day_entry == 'true'
            };
        }
    }

    pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
        this.page.offset = pageInfo.offset;
        this.getBackupFollowUpClientList();
    }
    onOpenedFilter(): void {
        setTimeout(function () {
            $('#filterSearch').focus();
        }, 100);

    }

    clearFilter(): void {
        this.filterData = {};
        this.filterData['year'] = this.currentYear;
        this.filterData['from_date'] = new Date(this.currentYear, 0, 1);
        this.filterData['to_date'] = new Date(this.currentYear, 11, 31);
        this.applyFilter();
    }

    applyFilter(): void {
        this.page.offset = 0;
        this.filterPanel.close();
        this.getBackupFollowUpClientList();
    }

    getBackupFollowUpClientList(): void {
        let branch_ids = "";
        if (!_.isEmpty(this.filterData["branch"])) {
            branch_ids = "'" + this.filterData["branch"].join("','") + "'";
            console.log(branch_ids);
        }
        let params = {
            start: `${this.page.offset}`,
            limit: `${this.page.limit}`,
            orderColumn: `${this.page.orderBy}`,
            orderDir: `${this.page.orderDir}`,
            branch: branch_ids,
            col_status: this.filterData['col_status'],
            folupstatus: this.filterData['fol_id'],
            fol_status: this.filterData['fol_status'],
            // branch: this.filterData['branch']
        };
        if (_.isDate(this.filterData['from_date'])) {
            params['from_date'] = moment(this.filterData['from_date']).format('YYYY-MM-DD');
        }
        if (_.isDate(this.filterData['to_date'])) {
            params['to_date'] = moment(this.filterData['to_date']).format('YYYY-MM-DD');
        }
        let that = this;
        this.isLoadMask = this.backupFollowUpClientService.getBackupFollowUpClientList(params)
            .then(function (res: any) {
                that.loadingIndicator = false;
                that.page.count = res.totCnt;
                that.backupFollowUpClientList = res.data;
                that.followUpListdt = res.listdt;
                that.hasOwnRecord = res.hasOwnRecord;

                that.totTask = res.totCnt;
                that.comTask = 0;
                if (res.data.length > 0) {
                    that.comTask = res.data[0]['com_task'];
                }
            });
    }

    displayFollowup(fol_id: number) {
        if (fol_id && this.followupNameList.length > 0) {
            let fitem = _.find(this.followupNameList, { 'fol_id': fol_id });
            return fitem['name'];
        }
        return '';
    }

    onSelect({ selected }) {
        this.selected.splice(0, this.selected.length);
        this.selected.push(...selected);
        console.log("ONSELECT", selected);
    }

    moveClient() {
        console.log("selected", this.selected);
        this.selectedArray = JSON.stringify(this.selected);
        console.log("selectedarray", this.selectedArray);

        const that = this;
        let params = {
            data: this.selectedArray,
            uploadType: 'backupScreen'
        };
        console.log("params", params);

        this.isLoadMask = this.backupFollowUpClientService
            .saveFile(params)
            .then(function (res: any) {
                if (res.success) {
                    that.selectedArray = [];
                    swal(res.message);
                    that.subscribeService.subScribeDeleteActiveTab();
                } else {
                    swal({
                        title: res.message,
                        text: res.subMessage
                    });
                }

            });
    }

}




// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/backupFollowUpClient/backupFollowUpClient.component.ts